import Modal from '../Modal'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Button } from '../Form'
import { pxToRem, color } from '../../utils'

const Wrapper = styled.div``

const ModalContent = styled.div`
  padding: ${pxToRem('20px')};
  font-size: ${pxToRem(13)};
`

const Footer = styled.div`
  padding: ${pxToRem(13)} ${pxToRem(16)};
  border-top: 1px solid #d8d8d8;

  display: flex;
  justify-content: flex-end;
`

const CancelButton = styled(Button)`
  background: ${color.danger};
  color: #fff;
  border-color: ${color.danger};

  &:hover,
  &:focus {
    box-shadow: 0 0 ${pxToRem('15px')} 0 ${color.danger};
    outline: none;
  }
  &:active {
    box-shadow: inset 0 0 ${pxToRem('5px')} 0 ${color.danger};
    border-color: ${color.danger};
  }
`

const ConfirmButton = styled(Button)`
  margin-left: ${pxToRem('15px')};
`

class Confirm extends React.PureComponent {
  confirmMethod = () => {
    typeof this.props.callback === 'function' && this.props.callback()
  }

  render() {
    const { confirmMethod } = this

    const {
      children,
      callback,
      cancelText = 'Cancelar',
      confirmText = 'Confirmar',
      closeMethod,
      size,
      loading,
      error,
      errorText,
      ...rest
    } = this.props

    return (
      <Wrapper>
        <Modal
          {...rest}
          safeContent={false}
          closeMethod={closeMethod}
          loading={loading}
          error={!!error}
          errorMessage={error}
          errorText={errorText}
          size={'small'}
        >
          {!error ? (
            <Fragment>
              <ModalContent>{children}</ModalContent>

              <Footer>
                <CancelButton onClick={closeMethod}>{cancelText}</CancelButton>
                <ConfirmButton disabled={loading} onClick={confirmMethod}>
                  {confirmText}
                </ConfirmButton>
              </Footer>
            </Fragment>
          ) : (
            <ModalContent>
              <span>{error}</span>
            </ModalContent>
          )}
        </Modal>
      </Wrapper>
    )
  }
}

export default Confirm



// WEBPACK FOOTER //
// ./src/components/Confirm/Confirm.js